import { AirFilterTabsResponse } from '@shared/filters/entities/fetch-filters.response';
import { getOrderCriteriaAux } from '@flight-results/mappers/filters.mapper';
import { SorterTypes } from '@shared/filters/entities/sorter-options';

export const mapAirFilterTabs = (tabs: AirFilterTabsResponse[], totalLength: number): AirFilterTabsResponse[] => {
  const response = [];
  const schedules = [];
  tabs.forEach(tab => {
    if (tab.OrderCriteria === SorterTypes.Arrival || tab.OrderCriteria === SorterTypes.Departure) {
      schedules.push({
        ...tab,
        SectorNumber: 1,
        OrderDesc: false,
        OrderCriteriaAux: getOrderCriteriaAux(tab.OrderCriteria, 1, false),
      });
      schedules.push({
        ...tab,
        SectorNumber: 1,
        OrderDesc: true,
        OrderCriteriaAux: getOrderCriteriaAux(tab.OrderCriteria, 1, true),
      });
      if (totalLength > 1) {
        schedules.push({
          ...tab,
          SectorNumber: 2,
          OrderDesc: false,
          OrderCriteriaAux: getOrderCriteriaAux(tab.OrderCriteria, 2, false),
        });
        schedules.push({
          ...tab,
          SectorNumber: 2,
          OrderDesc: true,
          OrderCriteriaAux: getOrderCriteriaAux(tab.OrderCriteria, 2, true),
        });
      }
    } else {
      response.push({
        ...tab,
        OrderCriteriaAux: tab.OrderCriteria
      });
    }
  });
  const orderSchedules = [...schedules].sort((scheduleA, scheduleB) => scheduleA.SectorNumber - scheduleB.SectorNumber);
  return [...response].concat(orderSchedules);
}
